import { ClassicPreset, type GetSchemes } from 'rete'
import type { ReactArea2D } from 'rete-react-plugin'
import type { Instacart_Catalog_Catflow_V1_StepVersion } from '../../../../../api'
import { type PipelineEditorProps } from '../PipelineEditor.tsx'
import { type PipelineStep } from '../../../../../types/attributeManagement.types.ts'
import type { PipelineEditorStepNode } from './nodes.tsx'

export interface PipelineEditorStepNodeInput {
  step: PipelineStep
  stepVersion: Instacart_Catalog_Catflow_V1_StepVersion | null | undefined
  props: PipelineEditorProps
}

export interface PipelineEditorProcessedState {
  isValid: boolean
  errors: PipelineEditorNodeError[]
}

export interface PipelineEditorNodeError {
  pipelineStepId?: string
  message: string
}

// Defines the types of node
export type NodeProps =
  | PipelineEditorStepNode
  | (ClassicPreset.Node & { width: number; height: number })

// This defines a generic connection class that works with nodes of type NodeProps
export class Connection<N extends NodeProps> extends ClassicPreset.Connection<N, N> {}

// This represents connections where the source and target can be any instance of NodeProps
export type ConnProps = Connection<NodeProps>

// Defines the editor's nodes and connections
export type Schemes = GetSchemes<NodeProps, ConnProps>

// Defines the render area scheme
export type AreaExtra = ReactArea2D<Schemes>
